import axios from 'axios';
import config from '../../../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../../../core/modules/common/tools/URLTools';

const apiFetchPredesPlannedTransportAnomaliesOriginSummary = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getPredesPlannedTransportAnomaliesOriginSummary',
    stub: config.useStubbedEndpoints,
  });

  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchPredesPlannedTransportAnomaliesOriginSummary;
